// Module
var code = `<div class="slide-content slide-content-type">
    <div class="accent-bar"></div>

    <div class="title-zone">
        <h1>{{title}}</h1>
    </div>

    <div class="content-zone">
        <p class="headline">{{content.headline}}</p>

        <div class="points-container">
            {{#content.points}}
            <div class="point-item">
                <div class="accent-line"></div>
                <div class="point-content">
                    <p class="point-title">{{title}}</p>
                    <p class="point-detail">{{detail}}</p>
                </div>
            </div>
            {{/content.points}}

            {{#content.capabilities}}
            <div class="point-item">
                <div class="accent-line"></div>
                <div class="point-content">
                    <p class="point-title">{{title}}</p>
                    <p class="point-detail">{{detail}}</p>
                </div>
            </div>
            {{/content.capabilities}}

            {{#content.metrics}}
            <div class="point-item metric-item">
                <div class="metric-circle">
                    <p class="metric-value">{{value}}</p>
                </div>
                <div class="point-content">
                    <p class="point-title">{{label}}</p>
                    <p class="point-detail">{{description}}</p>
                </div>
            </div>
            {{/content.metrics}}

            {{#content.components}}
            <div class="point-item component-item">
                <div class="accent-line"></div>
                <div class="point-content">
                    <p class="component-name">✓ {{name}}</p>
                    <p class="point-detail">{{status}}</p>
                </div>
            </div>
            {{/content.components}}

            {{#content.features}}
            <div class="point-item feature-item">
                <div class="accent-line"></div>
                <div class="point-content">
                    <p class="feature-name">{{name}}</p>
                    <p class="point-detail">{{description}}</p>
                </div>
            </div>
            {{/content.features}}
        </div>

        <div class="conclusion-box">
            <p>{{content.conclusion}}</p>
        </div>
    </div>
</div>
`;
// Exports
module.exports = code;